export default {
  unavailable: {
    title: 'Faktury dla klientów są niedostępne',
    description:
      'Goście zamawiający w Twoich restauracjach nie mogą prosić o fakturę, więc nie ma tu nic do skonfigurowania. Paragony i faktury wystawiane przez dostawcę nie są objęte zmianą.',
  },
};
